import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object({
    fullName: Yup.string().required("Full Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    dob: Yup.date().required("Date of Birth is required"),
    age: Yup.number().required("Age is required").positive().integer(),
    gender: Yup.string().required("Gender is required"),
    contactNo: Yup.string().required("Contact number is required"),
    education: Yup.string().required("Education is required"),
    currentWork: Yup.string().required("Current work is required"),
    english: Yup.string().required("English % is required"),

    residentialAddress: Yup.string().required("Residential address is required"),
    residentialPincode: Yup.string().required("Pincode is required"),
    residentialCity: Yup.string().required("City is required"),
    residentialState: Yup.string().required("State is required"),
    residentialContact: Yup.string().required("Contact No is required"),

    aadhaarNumber: Yup.string()
        .matches(/^\d{12}$/, "Must be 12 digits")
        .required("Aadhaar number is required"),
    panNumber: Yup.string()
        .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN number")
        .required("PAN is required"),
    accountNumber: Yup.string().required("Account number is required"),
    accountHolder: Yup.string().required("Account holder name is required"),
    ifsc: Yup.string().required("IFSC is required"),
    bankName: Yup.string().required("Bank name is required"),
    branchName: Yup.string().required("Branch name is required"),
    accountType: Yup.string().required("Account type is required"),
    agree: Yup.boolean().oneOf([true], "You must accept terms"),
});

const SinglePageManagerDetails = () => {
    const [aadhaarFrontPreview, setAadhaarFrontPreview] = useState(null);
    const [aadhaarBackPreview, setAadhaarBackPreview] = useState(null);
    const [panPreview, setPanPreview] = useState(null);
    const [chequePreview, setChequePreview] = useState(null);
    const [agreementPreview, setAgreementPreview] = useState(null);

    const handleImagePreview = (e, setPreview) => {
        const file = e.target.files[0];
        if (file) {
            setPreview(URL.createObjectURL(file));
        }
    };

    return (
        <div className="max-w-full mx-auto p-6 bg-white shadow rounded-lg">
            <h2 className="text-2xl font-bold mb-6">Registration Form</h2>
            <Formik
                initialValues={{
                    fullName: "",
                    email: "",
                    dob: "",
                    age: "",
                    gender: "",
                    contactNo: "",
                    altContact: "",
                    education: "",
                    currentWork: "",
                    english: "",

                    residentialAddress: "",
                    residentialPincode: "",
                    residentialCity: "",
                    residentialState: "",
                    residentialContact: "",

                    aadhaarNumber: "",
                    panNumber: "",
                    accountNumber: "",
                    accountHolder: "",
                    ifsc: "",
                    bankName: "",
                    branchName: "",
                    city: "",
                    state: "",
                    accountType: "",

                    agree: false,
                }}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                    // console.log("Form Data:", values);
                    alert("Form submitted successfully ✅");
                }}
            >
                {({ setFieldValue }) => (
                    <Form className="space-y-8">
                        {/* Personal Info */}
                        <section>
                            <h3 className="text-lg font-semibold mb-2">
                                Personal Information
                            </h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block mb-1 font-medium">Full Name *</label>
                                    <Field
                                        name="fullName"
                                        placeholder="Enter your full name"
                                        className="border p-2 w-full rounded"
                                    />
                                    <ErrorMessage
                                        name="fullName"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">Email *</label>
                                    <Field
                                        name="email"
                                        type="email"
                                        placeholder="Enter your email"
                                        className="border p-2 w-full rounded"
                                    />
                                    <ErrorMessage
                                        name="email"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">
                                        Date of Birth *
                                    </label>
                                    <Field
                                        name="dob"
                                        type="date"
                                        className="border p-2 w-full rounded"
                                    />
                                    <ErrorMessage
                                        name="dob"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">Age *</label>
                                    <Field
                                        name="age"
                                        type="number"
                                        placeholder="Enter your age"
                                        className="border p-2 w-full rounded"
                                        onWheel={(e) => e.target.blur()} // stop mouse wheel
                                        onKeyDown={(e) => {
                                            if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                                                e.preventDefault(); // block arrows ↑ ↓
                                            }
                                        }}
                                    />
                                    <ErrorMessage
                                        name="age"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">Gender *</label>
                                    <Field
                                        as="select"
                                        name="gender"
                                        className="border p-2 w-full rounded"
                                    >
                                        <option value="">Select Gender</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                    </Field>
                                    <ErrorMessage
                                        name="gender"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">
                                        Contact No. *
                                    </label>
                                    <Field
                                        name="contactNo"
                                        placeholder="Enter primary contact number"
                                        className="border p-2 w-full rounded"
                                    />
                                    <ErrorMessage
                                        name="contactNo"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">
                                        Alternate Contact
                                    </label>
                                    <Field
                                        name="altContact"
                                        placeholder="Enter alternate contact (optional)"
                                        className="border p-2 w-full rounded"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">Education *</label>
                                    <Field
                                        name="education"
                                        placeholder="Enter your education"
                                        className="border p-2 w-full rounded"
                                    />
                                    <ErrorMessage
                                        name="education"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">
                                        Current Work *
                                    </label>
                                    <Field
                                        name="currentWork"
                                        placeholder="Enter your current job or business"
                                        className="border p-2 w-full rounded"
                                    />
                                    <ErrorMessage
                                        name="currentWork"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">
                                        English Language (%)
                                    </label>
                                    <Field
                                        as="select"
                                        name="english"
                                        className="border p-2 w-full rounded"
                                    >
                                        <option value="">Select Percentage</option>
                                        <option value="50%">50%</option>
                                        <option value="75%">75%</option>
                                        <option value="100%">100%</option>
                                    </Field>
                                    <ErrorMessage
                                        name="english"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>
                            </div>
                        </section>

                        {/* Address */}
                        <section>
                            <h3 className="text-lg font-semibold mb-2">Address Details</h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block mb-1 font-medium">
                                        Residential Address *
                                    </label>
                                    <Field
                                        name="residentialAddress"
                                        placeholder="Enter full address"
                                        className="border p-2 w-full rounded"
                                    />
                                    <ErrorMessage
                                        name="residentialAddress"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">
                                        Residential Pincode *
                                    </label>
                                    <Field
                                        name="residentialPincode"
                                        placeholder="Enter pincode"
                                        className="border p-2 w-full rounded"
                                    />
                                    <ErrorMessage
                                        name="residentialPincode"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">
                                        Residential City *
                                    </label>
                                    <Field
                                        name="residentialCity"
                                        placeholder="Enter city"
                                        className="border p-2 w-full rounded"
                                    />
                                    <ErrorMessage
                                        name="residentialCity"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">
                                        Residential State *
                                    </label>
                                    <Field
                                        name="residentialState"
                                        placeholder="Enter state"
                                        className="border p-2 w-full rounded"
                                    />
                                    <ErrorMessage
                                        name="residentialState"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">
                                        Contact No. *
                                    </label>
                                    <Field
                                        name="residentialContact"
                                        placeholder="Enter Contact No."
                                        className="border p-2 w-full rounded"
                                    />
                                    <ErrorMessage
                                        name="residentialContact"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>
                            </div>
                        </section>

                        {/* KYC */}
                        <section>
                            <h3 className="text-lg font-semibold mb-2">KYC Details</h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block mb-1 font-medium">
                                        Aadhaar Number *
                                    </label>
                                    <Field
                                        name="aadhaarNumber"
                                        placeholder="Enter 12-digit Aadhaar number"
                                        className="border p-2 w-full rounded"
                                    />
                                    <ErrorMessage
                                        name="aadhaarNumber"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">
                                        Aadhaar Front Image *
                                    </label>
                                    <input
                                        type="file"
                                        onChange={(e) => {
                                            setFieldValue("aadhaarFront", e.target.files[0]);
                                            handleImagePreview(e, setAadhaarFrontPreview);
                                        }}
                                    />
                                    {aadhaarFrontPreview && (
                                        <img
                                            src={aadhaarFrontPreview}
                                            alt="Aadhaar Front"
                                            className="w-20 mt-2 border"
                                        />
                                    )}
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">
                                        Aadhaar Back Image *
                                    </label>
                                    <input
                                        type="file"
                                        onChange={(e) => {
                                            setFieldValue("aadhaarBack", e.target.files[0]);
                                            handleImagePreview(e, setAadhaarBackPreview);
                                        }}
                                    />
                                    {aadhaarBackPreview && (
                                        <img
                                            src={aadhaarBackPreview}
                                            alt="Aadhaar Back"
                                            className="w-20 mt-2 border"
                                        />
                                    )}
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">
                                        PAN Number *
                                    </label>
                                    <Field
                                        name="panNumber"
                                        placeholder="Enter 10-character PAN number"
                                        className="border p-2 w-full rounded"
                                    />
                                    <ErrorMessage
                                        name="panNumber"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">PAN Card *</label>
                                    <input
                                        type="file"
                                        onChange={(e) => {
                                            setFieldValue("panCard", e.target.files[0]);
                                            handleImagePreview(e, setPanPreview);
                                        }}
                                    />
                                    {panPreview && (
                                        <img
                                            src={panPreview}
                                            alt="PAN"
                                            className="w-20 mt-2 border"
                                        />
                                    )}
                                </div>
                            </div>
                        </section>

                        {/* Bank */}
                        <section>
                            <h3 className="text-lg font-semibold mb-2">Bank Details</h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block mb-1 font-medium">
                                        Account Number *
                                    </label>
                                    <Field
                                        name="accountNumber"
                                        placeholder="Enter account number"
                                        className="border p-2 w-full rounded"
                                    />
                                    <ErrorMessage
                                        name="accountNumber"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">
                                        Account Holder Name *
                                    </label>
                                    <Field
                                        name="accountHolder"
                                        placeholder="Enter account holder name"
                                        className="border p-2 w-full rounded"
                                    />
                                    <ErrorMessage
                                        name="accountHolder"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">IFSC Code *</label>
                                    <Field
                                        name="ifsc"
                                        placeholder="Enter IFSC code"
                                        className="border p-2 w-full rounded"
                                    />
                                    <ErrorMessage
                                        name="ifsc"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">Bank Name *</label>
                                    <Field
                                        name="bankName"
                                        placeholder="Enter bank name"
                                        className="border p-2 w-full rounded"
                                    />
                                    <ErrorMessage
                                        name="bankName"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">Branch Name *</label>
                                    <Field
                                        name="branchName"
                                        placeholder="Enter branch name"
                                        className="border p-2 w-full rounded"
                                    />
                                    <ErrorMessage
                                        name="branchName"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">
                                        Account Type *
                                    </label>
                                    <Field
                                        as="select"
                                        name="accountType"
                                        className="border p-2 w-full rounded"
                                    >
                                        <option value="">Select account type</option>
                                        <option value="Saving">Saving</option>
                                        <option value="Current">Current</option>
                                    </Field>
                                    <ErrorMessage
                                        name="accountType"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">
                                        Cancelled Cheque *
                                    </label>
                                    <input
                                        type="file"
                                        onChange={(e) => {
                                            setFieldValue("cancelledCheque", e.target.files[0]);
                                            handleImagePreview(e, setChequePreview);
                                        }}
                                    />
                                    {chequePreview && (
                                        <img
                                            src={chequePreview}
                                            alt="Cheque"
                                            className="w-20 mt-2 border"
                                        />
                                    )}
                                </div>
                            </div>
                        </section>

                        {/* Agreement */}
                        <section>
                            <h3 className="text-lg font-semibold mb-2">Agreement Details</h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div className="flex items-center gap-2">
                                    <Field type="checkbox" name="agree" />
                                    <label>I agree to the Terms & Conditions *</label>
                                    <ErrorMessage
                                        name="agree"
                                        component="div"
                                        className="text-red-500 text-sm"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1 font-medium">
                                        Upload Agreement *
                                    </label>
                                    <input
                                        type="file"
                                        onChange={(e) => {
                                            setFieldValue("agreement", e.target.files[0]);
                                            handleImagePreview(e, setAgreementPreview);
                                        }}
                                    />
                                    {agreementPreview && (
                                        <img
                                            src={agreementPreview}
                                            alt="Agreement"
                                            className="w-20 mt-2 border"
                                        />
                                    )}
                                </div>
                            </div>
                        </section>

                        {/* Submit */}
                        <button
                            type="submit"
                            className="bg-blue-600 text-white px-6 py-2 rounded"
                        >
                            Submit
                        </button>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default SinglePageManagerDetails;
